var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjetos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2,5 L18,5 L18,9 L2,9 L2,5 Z M6,10 L22,10 L22,14 L6,14 L6,10 Z M6,15 L22,15 L22,19 L6,19 L6,15 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjetos);
export default __webpack_public_path__ + "static/media/projetos.224707acd5747a402ee70eb4fd8033de.svg";
export { ForwardRef as ReactComponent };